// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_SubscriptionSaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /platform-webhooks/subscription-save — upsert by plugin name.
 * `secret` blank on create = the platform mints one and returns it ONCE;
 * blank on update = keep the current one.
 */
import { registerContract } from './validate'

export interface PlatformWebhooks_SubscriptionSaveInput {
plugin?: string
url?: string
events?: string[]
secret?: string
enabled?: boolean
contract?: string
delivery?: string
}

registerContract('PlatformWebhooks_SubscriptionSaveInput', {
  plugin:   { type: 'string',  required: false },
  url:      { type: 'string',  required: false },
  events:   { type: 'array',   required: false },
  secret:   { type: 'string',  required: false },
  enabled:  { type: 'boolean', required: false },
  contract: { type: 'string',  required: false },
  delivery: { type: 'string',  required: false },
})
